module.exports = import("https://cdn.jsdelivr.net/npm/hls.js@1/+esm");;